<script lang="ts">
import { onMount } from "svelte";
import type { Client } from "../Model/Client";
import { navigate } from "svelte-navigator";
import { endSession, getCurrentUser, isLoggedIn } from "../services/session";
import { Button, Icon } from "sveltestrap";




let client: Client;

onMount(() => {
  if (!isLoggedIn()) {
    navigate('/login')
    return;
  }

  client = getCurrentUser();

})


</script>

<style lang="scss">

  .content-header{
    background-color: #0E3CA5;
    height: 75px;
    width: 100%;

    img{
      height: 75%;
      margin-left: 25px;
    }
  }

  :global(#button-out-client){
    margin-right: 10px;
    color: #fff;
  }

</style>

{#if client}
  <div class="content-header d-flex align-items-center justify-content-between">
      <img src="/img/BuenavistaEscudo.png" alt="">
      <Button id="button-out-client" color="link" type="button" on:click={() => {
        endSession()
        navigate('/login')}
        }>
          <img src="/img/out-icon.png" alt="">
        </Button>
  </div>
{/if}